import React from "react";

import { IntlFormatUSD } from "../../../../../../utils";
import { getReportValues } from "../../utils";
import { INetSalesValuesReport } from "../../../../../../api/billing/index.types";
import { NET_SALES_CALCULATOR_TAB_INDEXES } from "../../constants";

interface IProps {
  report: INetSalesValuesReport;
  activeTabIndex: NET_SALES_CALCULATOR_TAB_INDEXES;
}
const PaymentProvidersData: React.FC<IProps> = ({ report, activeTabIndex }) => {
  const {
    totalNet,
    sumRefAndChar,
    paypalNetTotal,
    payPalGrossTotal,
    stripeNetTotal,
    stripeGrossTotal,
    bridgerPayGrossTotal,
    bridgerPayNetTotal,
    letknowPayGrossTotal,
    letknowPayNetTotal,
  } = getReportValues(report, activeTabIndex);

  return (
    <div>
      <ul style={{ paddingLeft: "30px" }}>
        <li>
          Stripe payments total gross{" "}
          <span data-test="stripe-total-gross">{IntlFormatUSD(stripeGrossTotal / 100)}</span>
        </li>
        <li>
          Stripe payments total Net{" "}
          <span data-test="stripe-total-net">{IntlFormatUSD(stripeNetTotal / 100)}</span>
        </li>
        <hr />
        <li>
          Paypal payments total gross{" "}
          <span data-test="paypal-total-gross">{IntlFormatUSD(payPalGrossTotal / 100)}</span>
        </li>
        <li>
          Paypal payments total Net{" "}
          <span data-test="paypal-total-net">{IntlFormatUSD(paypalNetTotal / 100)}</span>
        </li>
        <hr />
        <li>
          BitPay payments total gross{" "}
          <span data-test="not_us_bitpay_total_gross">
            {IntlFormatUSD((report.not_us_bitpay_total_gross ?? 0) / 100)}
          </span>
        </li>
        <li>
          BitPay payments total Net{" "}
          <span data-test="not_us_bitpay_total_net">
            {IntlFormatUSD((report.not_us_bitpay_total_net ?? 0) / 100)}
          </span>
        </li>
        <hr />
        <li>
          BridgerPay payments total gross <span>{IntlFormatUSD(bridgerPayGrossTotal / 100)}</span>
        </li>
        <li>
          BridgerPay payments total Net <span>{IntlFormatUSD(bridgerPayNetTotal / 100)}</span>
        </li>
        <hr />
        <li>
          LetKnowPay payments total gross{" "}
          <span data-test="letknowpay-total-gross">{IntlFormatUSD(letknowPayGrossTotal / 100)}</span>
        </li>
        <li>
          LetKnowPay payments total Net{" "}
          <span data-test="letknowpay-total-net">{IntlFormatUSD(letknowPayNetTotal / 100)}</span>
        </li>
        <hr />
        <li>
          Sum of refunds and chargebacks{" "}
          <span data-test="refunds-chargebacks">-{IntlFormatUSD(sumRefAndChar / 100)}</span>
        </li>
        <li>
          Total Net <span data-test="total-net">{IntlFormatUSD(totalNet / 100)}</span>
        </li>
      </ul>
    </div>
  );
};

export default PaymentProvidersData;
